import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import ExportReport from '@/views/keiei-joho/keiei-info/ExportReport.vue'
import keieiJokyoSetting from '@/views/keiei-joho/keiei-info/KeieiJokyoSettings.vue'
import keieiJokyoRegister from '@/views/keiei-joho/keiei-info/KeieiJokyoRegister.vue'
import shokushuSetting from '@/views/keiei-joho/keiei-info/ShokushuSettings.vue'
import shokushuRegister from '@/views/keiei-joho/keiei-info/ShokushuRegister.vue'

export const keieiInfoRoute: RouteRecordRaw = {
  path: '/keiei',
  component: BaseLayoutView,
  children: [
    {
      path: 'keiei-info',
      children: [
        { path: 'export', component: ExportReport },
        { path: 'register/jokyo', component: keieiJokyoRegister },
        { path: 'register/shokushu', component: shokushuRegister },
        { path: 'setting/jokyo', component: keieiJokyoSetting },
        { path: 'setting/shokushu', component: shokushuSetting }
      ]
    }
  ]
}
